import React from "react";

export default function LegalDocumentPage({ document }) {
  return (
    <main className="min-h-screen bg-[#FCFBF9] text-zinc-950">
      <header className="border-b border-zinc-200/80 bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-5 sm:px-6">
          <a href="/" className="flex items-center gap-3">
            <div className="grid h-11 w-11 place-items-center rounded-[14px] bg-[#EA580C] font-black text-white">
              W
            </div>
            <div>
              <div className="text-base font-extrabold">Web Menü</div>
              <div className="mt-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-zinc-400">
                Megriva teknolojisiyle
              </div>
            </div>
          </a>

          <a
            href="/"
            className="rounded-full border border-zinc-200 bg-white px-4 py-2 text-sm font-bold text-zinc-700 hover:bg-zinc-50"
          >
            Ana Sayfa
          </a>
        </div>
      </header>

      <section className="border-b border-zinc-200 bg-white">
        <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 sm:py-16">
          <span className="inline-flex rounded-full bg-orange-50 px-3 py-1.5 text-xs font-extrabold uppercase tracking-[0.14em] text-[#EA580C]">
            Yasal
          </span>
          <h1 className="mt-5 text-4xl font-black tracking-[-0.04em] sm:text-5xl">
            {document.title}
          </h1>
          <p className="mt-4 text-sm font-semibold text-zinc-400">
            Son güncelleme: {document.updatedAt}
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 sm:py-14">
        <article className="rounded-[28px] border border-zinc-200 bg-white p-6 shadow-sm sm:p-9">
          <div className="space-y-4 text-[15px] font-medium leading-8 text-zinc-600">
            {document.intro.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>

          <div className="mt-10 space-y-10">
            {document.sections.map((section) => (
              <section key={section.title}>
                <h2 className="text-xl font-extrabold tracking-[-0.02em] sm:text-2xl">
                  {section.title}
                </h2>

                {section.paragraphs?.length ? (
                  <div className="mt-4 space-y-4 text-[15px] font-medium leading-8 text-zinc-600">
                    {section.paragraphs.map((paragraph) => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                  </div>
                ) : null}

                {section.bullets?.length ? (
                  <ul className="mt-5 space-y-3">
                    {section.bullets.map((bullet) => (
                      <li
                        key={bullet}
                        className="flex gap-3 text-[15px] font-medium leading-7 text-zinc-600"
                      >
                        <span className="mt-2.5 h-2 w-2 shrink-0 rounded-full bg-[#EA580C]" />
                        <span>{bullet}</span>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </section>
            ))}
          </div>
        </article>
      </div>
    </main>
  );
}
